import React from "react";
import oNas1 from "../../assets/img/about/oNas1.jpg";
import oNas2 from "../../assets/img/about/oNas2.jpg";
import TwoImages from "./TwoImages";

export default function Most({ children }) {
  return (
    <>
      <section className="about-area py-5 p-relative fix">
        <div className="container">
          <div className="row justify-content-center align-items-top">
            <div className="col-md-6 col-lg-5 order-md-2">{children}</div>
            <div
              className="col-md-6 col-lg-7 order-md-1"
              style={{ paddingTop: "40px" }}
            >
              <TwoImages imgSrc1={oNas1} imgSrc2={oNas2} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
